import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import {browserHistory, withRouter} from 'react-router';
import Breadcrumbs from 'components/pure/utils/Breadcrumbs';
import FeedbackRuleWizard from './FeedbackRuleWizard';
import TriggerRuleStore from 'stores/triggers/TriggerRuleStore';
import TriggerRuleActions from 'actions/triggers/TriggerRuleActions';
import CallRuleWizard from 'components/triggers/CallRuleWizard';
import {unsavedMessage} from 'utils/const';

class EditTriggerRule extends React.Component {
  constructor(props) {
    super(props);

    this.cancelClick = this.cancelClick.bind(this);
    this.saveTriggerClick = this.saveTriggerClick.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);

    this.state = {
      rule: null,
      confirmLeave: true,
    };
  }

  static getStores() {
    return [TriggerRuleStore];
  }

  static getPropsFromStores(nextProps) {
    if (!nextProps) {
      return {};
    }
    const {rules} = TriggerRuleStore.getState();
    return {
      rule: rules.get(nextProps.params.ruleId),
    };
  }

  cancelClick() {
    this.setState({confirmLeave: false});
    const ruleId = this.props.params.ruleId;
    setTimeout(() => browserHistory.push(`/admin/actions/${ruleId}`), 0);
  }

  saveTriggerClick(rule) {
    this.setState({confirmLeave: false});
    const ruleId = this.props.params.ruleId;
    TriggerRuleActions.updateTriggerRule(ruleId, rule).then(() => {
      browserHistory.push(`/admin/actions/${ruleId}/edit-details`);
    });
  }

  componentDidMount() {
    const {rule} = this.props;
    const ruleId = this.props.params.ruleId;
    if (!rule) {
      TriggerRuleActions.fetchTriggerRule(ruleId);
    }

    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  }

  routerWillLeave() {
    if (this.state.confirmLeave) {
      return unsavedMessage;
    }
  }

  renderSelectedRuleType(rule) {
    if (rule.context.type === 'feedback_trigger') {
      return (
        <FeedbackRuleWizard
          rule={rule.context}
          cancelClick={this.cancelClick}
          saveTriggerClick={this.saveTriggerClick}
        />
      );
    } else {
      return (
        <CallRuleWizard
          rule={rule.context}
          cancelClick={this.cancelClick}
          saveTriggerClick={this.saveTriggerClick}
        />
      );
    }
  }

  render() {
    const ruleId = this.props.params.ruleId;
    const {rule} = this.props;

    const breadcrumbLinks = [
      {url: '/admin/actions', name: 'Rules'},
      {url: `/admin/actions/${ruleId}/edit`, name: 'Edit rule'},
    ];
    if (!rule) {
      return null;
    }
    if (rule.rulePermissions.EDIT === undefined) {
      return null;
    }
    return (
      <div className="triggers-page">
        <h1>Edit Rule</h1>
        <Breadcrumbs links={breadcrumbLinks} />
        {this.renderSelectedRuleType(rule)}
      </div>
    );
  }
}

export default withRouter(connectToStores(EditTriggerRule));
